"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("./TextareaField.css");

var _emojiMart = require("emoji-mart");

var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// Our main component
var TextareaField = /*#__PURE__*/function (_Component) {
  _inherits(TextareaField, _Component);

  var _super = _createSuper(TextareaField);

  function TextareaField(props) {
    var _this;

    _classCallCheck(this, TextareaField);

    _this = _super.call(this, props);
    _this.state = {
      active: false
    };
    _this.resizer = _this.resizer.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TextareaField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        value: this.props.value
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.value !== prevProps.value) {
        this.setState({
          value: this.props.value
        });
      }
    } // Handles the auto height of the textarea
    // depending on how long the content is

  }, {
    key: "resizer",
    value: function resizer(e) {
      e.target.style.height = "inherit";
      e.target.style.height = "".concat(e.target.scrollHeight + 1, "px");
    } // Inserts the social media icons from the picker
    // inside the textarea

  }, {
    key: "addToInput",
    value: function addToInput(e) {
      var val = this.state.value ? this.state.value : "";
      val = val + e[this.props.code ? this.props.code : "native"];
      this.setState({
        value: val
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          disabled = _this$props.disabled,
          error = _this$props.error,
          perLine = _this$props.perLine,
          placeholder = _this$props.placeholder,
          resize = _this$props.resize,
          set = _this$props.set,
          social_icons = _this$props.social_icons,
          template = _this$props.template,
          label = _this$props.label,
          defaultValue = _this$props.defaultValue;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "textareaFieldWrapper",
        onMouseLeave: function onMouseLeave() {
          return _this2.setState({
            active: false
          });
        }
      }, /*#__PURE__*/_react["default"].createElement("textarea", {
        "aria-label": label,
        className: "textareaField ".concat(error ? "error" : "", " ").concat(resize ? "resize" : "", " ").concat(template ? "temp_".concat(template) : ""),
        disabled: disabled,
        onChange: function onChange(e) {
          _this2.props.onChange && _this2.props.onChange(e);
          resize && _this2.resizer(e);

          _this2.setState({
            value: e.target.value
          });
        },
        placeholder: placeholder,
        value: this.state.value,
        defaultValue: defaultValue
      }), social_icons && /*#__PURE__*/_react["default"].createElement("div", {
        className: "textareaFieldIcons ".concat(this.state.active ? "active" : "")
      }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
        name: "Happy",
        onClick: function onClick() {
          return _this2.setState({
            active: !_this2.state.active
          });
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "textareaFieldIconPicker"
      }, /*#__PURE__*/_react["default"].createElement(_emojiMart.Picker, {
        onClick: function onClick(e) {
          return _this2.addToInput(e);
        },
        perLine: perLine ? perLine : 7,
        set: set ? set : "facebook"
      }))));
    }
  }]);

  return TextareaField;
}(_react.Component);

exports["default"] = TextareaField;